module.exports = __webpack_public_path__ + "media/recipes/60-f3039e7e.png";